<template>
  <div class="AD pt7 pl5 pr5 bc-white" v-title data-title="广告">
    <div class="row align-items-center">
      <div class="pr5">图片：</div>
      <div class="flex-1" style="height: 25vh">
        <van-uploader
          class="col"
          width="100%"
          v-model="fileList"
          multiple
          :max-count="1"
          :after-read="afterRead"
          :preview-full-image="false"
          image-fit="cover"
          @delete="deleteImage"
        />
      </div>
    </div>
    <div class="line"></div>
    <div class="row align-items-center pt5 pb5">
      <div class="pr5">位置：</div>
      <div class="flex-1 text-left">
        <select class="w100p" v-model="adInfo.position" >
          <option v-for="ps in positions" :value ="ps.value" :key="ps.value">
            {{ps.text}}
          </option>
        </select>
        <!-- <van-checkbox-group v-model="userinfo.position" direction="horizontal">
          <van-checkbox v-for="mn in positions" :name="mn.value" :key="mn.value" class="pt1 pb1">
            {{mn.name}}
          </van-checkbox>
        </van-checkbox-group> -->
      </div>
    </div>
    <div class="row align-items-baseline pt5 pb5">
      <div class="pr5">链接：</div>
      <div class="flex-1 text-left">
        <input class="w100p" v-model="adInfo.link" placeholder="请输入跳转链接">
        <div class="fc-red fs1">如当前广告为腾讯广告请输入banner或者video</div>
      </div>
    </div>
    <!-- <div class="line"></div>
    <div class="row align-items-center pt5 pb5">
      <div class="pr5">类目：</div>
      <div class="flex-1 text-left">
        <select class="" v-model="adInfo.type" >
          <option v-for="ps in types" :value ="ps.value" :key="ps.value">
            {{ps.text}}
          </option>
        </select>
      </div>
    </div> -->
    <div class="line"></div>
    <!-- <div class="pt10">
      <van-button class="btn-common" type="info" :loading="loading" loading-text="正在保存..."
        @click="save">保存</van-button>
    </div> -->
    <div class="row justify-content-around pr10 pl10 pt5 pb5">
      <van-button @click="back" class="btn-common" plain type="info">返回</van-button>
      <van-button @click="save" class="btn-common" type="info" :loading="loading" loading-text="正在保存...">保存</van-button>
    </div>

  </div>
</template>

<script>
import Vue from 'vue';
import { SWIPER_TYPES } from '@/uitls/const';
import config from '../../config';
import {
  sendRequest, uploadFile, getad, updateimages, upload,
} from '../../network/NetworkAccessor';

export default Vue.extend({
  name: 'AD',
  components: {},
  data() {
    return {
      loading: false,
      fileDomain: config.FILE_DOMAIN,
      adInfo: {
        position: '',
        file: '',
        link: '',
      },
      positions: [
        {
          text: '请选择',
          value: '',
        },
        ...SWIPER_TYPES,
      ],
      fileList: [],
    };
  },
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  methods: {
    deleteImage() {
      this.$set(this.adInfo, 'file', '');
      this.$set(this.adInfo, 'url', '');
      this.$set(this.adInfo, 'link', '');
      this.$set(this.adInfo, 'position', '');
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      this.$set(this.adInfo, 'url', '');
      this.$set(this.adInfo, 'file', file.file);
    },
    save() {
      const params = new FormData();
      if (this.adInfo.file) {
        params.append('file', this.adInfo.file);
        upload(uploadFile, params).then((url = '') => {
          this.adInfo.url = url;
          this.$set(this.adInfo, 'url', url);
          this.saveAd();
        }).catch((error) => {
          this.$dialog.alert({
            message: error.message || '啊哦，出错了',
          });
        });
        return;
      }
      this.saveAd();
      // sendRequest(adimages, this.adInfo).then((res) => {
      //   console.log(res);
      // }).catch((e) => {
      //   console.log(e);
      //   this.$dialog.alert({
      //     message: e.message || '啊哦，出错了',
      //   });
      // }).then(() => {
      //   // this.formatFileList();
      // });
    },
    saveAd() {
      const saveParams = { ...this.adInfo };
      delete saveParams.file;
      sendRequest(updateimages, saveParams).then(() => {
        this.back();
      }).catch((error) => {
        this.$dialog.alert({
          message: error.message || '啊哦，出错了',
        });
      });
    },
    back() {
      // this.$router.push('/AD/info/list');
      this.$router.back();
    },
    formatFileList() {
      if (this.adInfo.url) {
        this.fileList = [{
          url: this.fileDomain + this.adInfo.url,
        }];
      }
    },
    getAD() {
      if (!this.id) {
        return;
      }
      sendRequest(getad, { id: this.id }).then((res) => {
        // eslint-disable-next-line eqeqeq
        const adInfo = res;
        adInfo.position = adInfo.position || '';
        this.adInfo = adInfo;
      }).catch((e) => {
        console.log(e);
        this.$dialog.alert({
          message: e.message || '啊哦，出错了',
        });
      }).then(() => {
        this.formatFileList();
      });
    },
  },
  created() {
    this.getAD();
  },
});
</script>
<style scoped>
  .AD {
    min-height: 100vh;
  }
  .AD >>> .van-uploader, .AD >>> .van-uploader__wrapper, .AD >>> .van-uploader__upload, .AD >>> .van-uploader__preview{
    width: 100%;
    height: 100%;
  }
  .AD >>> .van-uploader__preview-image{
    width: 100%;
    height: 100%;
  }
  .ad-select {
    /* font-size: 15px; */
    /* border: 1px solid #eee; */
    text-align: center;
    text-align-last: center;
    width: 130px;
    border: 1px solid #eee;
    /* padding: 8px 0; */
    height: 30px;
  }
  .AD >>> .van-uploader__file {
    width: 100%;
  }
</style>
